import { Injectable, inject } from '@angular/core';
import { HTTP_AP_ActivateReferrals_Request } from '@api-new/userservice/HTTP_AP_ActivateReferrals_Request';
import { HTTP_AP_AddManagedAdvisorUsers_Request } from '@api-new/userservice/HTTP_AP_AddManagedAdvisorUsers_Request';
import { HTTP_AP_AddManagedAdvisorUsers_Response } from '@api-new/userservice/HTTP_AP_AddManagedAdvisorUsers_Response';
import { HTTP_AP_AddManagedCompanies_Request } from '@api-new/userservice/HTTP_AP_AddManagedCompanies_Request';
import { HTTP_AP_AddManagedCompanies_Response } from '@api-new/userservice/HTTP_AP_AddManagedCompanies_Response';
import { HTTP_AP_AdvisorUser } from '@api-new/userservice/HTTP_AP_AdvisorUser';
import { HTTP_AP_AdvisorUserPermissionSettings } from '@api-new/userservice/HTTP_AP_AdvisorUserPermissionSettings';
import { HTTP_AP_AdvisorUserSettingsForPermissions } from '@api-new/userservice/HTTP_AP_AdvisorUserSettingsForPermissions';
import { HTTP_AP_BulkCreateReferrals_Request } from '@api-new/userservice/HTTP_AP_BulkCreateReferrals_Request';
import { HTTP_AP_BulkSetClientUsersSettingsForNotifications_Request } from '@api-new/userservice/HTTP_AP_BulkSetClientUsersSettingsForNotifications_Request';
import { HTTP_AP_ClientUser } from '@api-new/userservice/HTTP_AP_ClientUser';
import { HTTP_AP_ClientUserEmployment } from '@api-new/userservice/HTTP_AP_ClientUserEmployment';
import { HTTP_AP_ClientUserSettingsForCreditReports } from '@api-new/userservice/HTTP_AP_ClientUserSettingsForCreditReports';
import { HTTP_AP_CreateAdvisorUser_Request } from '@api-new/userservice/HTTP_AP_CreateAdvisorUser_Request';
import { HTTP_AP_CreateClientUser_Request } from '@api-new/userservice/HTTP_AP_CreateClientUser_Request';
import { HTTP_AP_CreateReferral_Request } from '@api-new/userservice/HTTP_AP_CreateReferral_Request';
import { HTTP_AP_CreateTinyUrl_Request } from '@api-new/userservice/HTTP_AP_CreateTinyUrl_Request';
import { HTTP_AP_DeactivateReferrals_Request } from '@api-new/userservice/HTTP_AP_DeactivateReferrals_Request';
import { HTTP_AP_DeleteAdvisorUser_Request } from '@api-new/userservice/HTTP_AP_DeleteAdvisorUser_Request';
import { HTTP_AP_DeleteClientUser_Request } from '@api-new/userservice/HTTP_AP_DeleteClientUser_Request';
import { HTTP_AP_DeleteTinyUrl_Request } from '@api-new/userservice/HTTP_AP_DeleteTinyUrl_Request';
import { HTTP_AP_ExportClientUsersToCSV_Request } from '@api-new/userservice/HTTP_AP_ExportClientUsersToCSV_Request';
import { HTTP_AP_ExportReferralsToCSV_Request } from '@api-new/userservice/HTTP_AP_ExportReferralsToCSV_Request';
import { HTTP_AP_GetAdvisorUserSettingsForNotifications_Request } from '@api-new/userservice/HTTP_AP_GetAdvisorUserSettingsForNotifications_Request';
import { HTTP_AP_GetAdvisorUserSettingsForNotifications_Response } from '@api-new/userservice/HTTP_AP_GetAdvisorUserSettingsForNotifications_Response';
import { HTTP_AP_GetAdvisorUser_Request } from '@api-new/userservice/HTTP_AP_GetAdvisorUser_Request';
import { HTTP_AP_GetClientUserEmployment_Request } from '@api-new/userservice/HTTP_AP_GetClientUserEmployment_Request';
import { HTTP_AP_GetClientUserSettingsForCreditReports_Request } from '@api-new/userservice/HTTP_AP_GetClientUserSettingsForCreditReports_Request';
import { HTTP_AP_GetClientUserSettingsForNotifications_Request } from '@api-new/userservice/HTTP_AP_GetClientUserSettingsForNotifications_Request';
import { HTTP_AP_GetClientUserSettingsForNotifications_Response } from '@api-new/userservice/HTTP_AP_GetClientUserSettingsForNotifications_Response';
import { HTTP_AP_GetClientUser_FortClientHeader_Request } from '@api-new/userservice/HTTP_AP_GetClientUser_FortClientHeader_Request';
import { HTTP_AP_GetClientUser_FortClientHeader_Response } from '@api-new/userservice/HTTP_AP_GetClientUser_FortClientHeader_Response';
import { HTTP_AP_GetClientUser_Request } from '@api-new/userservice/HTTP_AP_GetClientUser_Request';
import { HTTP_AP_GetReferral_Request } from '@api-new/userservice/HTTP_AP_GetReferral_Request';
import { HTTP_AP_GetTinyUrl_Request } from '@api-new/userservice/HTTP_AP_GetTinyUrl_Request';
import { HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Request } from '@api-new/userservice/HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Request';
import { HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Response } from '@api-new/userservice/HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Response';
import { HTTP_AP_ListAdvisorUsers_ForSelect_Request } from '@api-new/userservice/HTTP_AP_ListAdvisorUsers_ForSelect_Request';
import { HTTP_AP_ListAdvisorUsers_ForSelect_Response } from '@api-new/userservice/HTTP_AP_ListAdvisorUsers_ForSelect_Response';
import { HTTP_AP_ListAdvisorUsers_ForTable_Request } from '@api-new/userservice/HTTP_AP_ListAdvisorUsers_ForTable_Request';
import { HTTP_AP_ListAdvisorUsers_ForTable_Response } from '@api-new/userservice/HTTP_AP_ListAdvisorUsers_ForTable_Response';
import { HTTP_AP_ListClientUserEmails_Request } from '@api-new/userservice/HTTP_AP_ListClientUserEmails_Request';
import { HTTP_AP_ListClientUserEmails_Response } from '@api-new/userservice/HTTP_AP_ListClientUserEmails_Response';
import { HTTP_AP_ListClientUserIds_Request } from '@api-new/userservice/HTTP_AP_ListClientUserIds_Request';
import { HTTP_AP_ListClientUserIds_Response } from '@api-new/userservice/HTTP_AP_ListClientUserIds_Response';
import { HTTP_AP_ListClientUsers_ForBulkDeletion_Request } from '@api-new/userservice/HTTP_AP_ListClientUsers_ForBulkDeletion_Request';
import { HTTP_AP_ListClientUsers_ForBulkDeletion_Response } from '@api-new/userservice/HTTP_AP_ListClientUsers_ForBulkDeletion_Response';
import { HTTP_AP_ListClientUsers_ForTable_Request } from '@api-new/userservice/HTTP_AP_ListClientUsers_ForTable_Request';
import { HTTP_AP_ListClientUsers_ForTable_Response } from '@api-new/userservice/HTTP_AP_ListClientUsers_ForTable_Response';
import { HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Request } from '@api-new/userservice/HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Request';
import { HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Response } from '@api-new/userservice/HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Response';
import { HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Request } from '@api-new/userservice/HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Request';
import { HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Response } from '@api-new/userservice/HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Response';
import { HTTP_AP_ListReferrals_Request } from '@api-new/userservice/HTTP_AP_ListReferrals_Request';
import { HTTP_AP_ListReferrals_Response } from '@api-new/userservice/HTTP_AP_ListReferrals_Response';
import { HTTP_AP_ListTinyUrls_Request } from '@api-new/userservice/HTTP_AP_ListTinyUrls_Request';
import { HTTP_AP_ListTinyUrls_Response } from '@api-new/userservice/HTTP_AP_ListTinyUrls_Response';
import { HTTP_AP_LoadAdvisorUserData_Response } from '@api-new/userservice/HTTP_AP_LoadAdvisorUserData_Response';
import { HTTP_AP_PurgeClientUsers_Request } from '@api-new/userservice/HTTP_AP_PurgeClientUsers_Request';
import { HTTP_AP_PurgeClientUsers_Response } from '@api-new/userservice/HTTP_AP_PurgeClientUsers_Response';
import { HTTP_AP_ReassignAdvisorUsers_Request } from '@api-new/userservice/HTTP_AP_ReassignAdvisorUsers_Request';
import { HTTP_AP_ReassignClientUsers_Request } from '@api-new/userservice/HTTP_AP_ReassignClientUsers_Request';
import { HTTP_AP_Referral } from '@api-new/userservice/HTTP_AP_Referral';
import { HTTP_AP_RemoveManagedAdvisorUsers_Request } from '@api-new/userservice/HTTP_AP_RemoveManagedAdvisorUsers_Request';
import { HTTP_AP_RemoveManagedCompanies_Request } from '@api-new/userservice/HTTP_AP_RemoveManagedCompanies_Request';
import { HTTP_AP_RemoveManagedCompanies_Response } from '@api-new/userservice/HTTP_AP_RemoveManagedCompanies_Response';
import { HTTP_AP_TinyUrl } from '@api-new/userservice/HTTP_AP_TinyUrl';
import { HTTP_AP_UpdateAdvisorUserEmail_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserEmail_Request';
import { HTTP_AP_UpdateAdvisorUserPermissionSettings_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserPermissionSettings_Request';
import { HTTP_AP_UpdateAdvisorUserPhoneNumber_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserPhoneNumber_Request';
import { HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Request';
import { HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Response } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Response';
import { HTTP_AP_UpdateAdvisorUserSettingsForPermissions_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUserSettingsForPermissions_Request';
import { HTTP_AP_UpdateAdvisorUser_Request } from '@api-new/userservice/HTTP_AP_UpdateAdvisorUser_Request';
import { HTTP_AP_UpdateClientUserEmail_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUserEmail_Request';
import { HTTP_AP_UpdateClientUserEmployment_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUserEmployment_Request';
import { HTTP_AP_UpdateClientUserPhoneNumber_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUserPhoneNumber_Request';
import { HTTP_AP_UpdateClientUserSettingsForCreditReports_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUserSettingsForCreditReports_Request';
import { HTTP_AP_UpdateClientUserSettingsForNotifications_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUserSettingsForNotifications_Request';
import { HTTP_AP_UpdateClientUserSettingsForNotifications_Response } from '@api-new/userservice/HTTP_AP_UpdateClientUserSettingsForNotifications_Response';
import { HTTP_AP_UpdateClientUser_Request } from '@api-new/userservice/HTTP_AP_UpdateClientUser_Request';
import { HTTP_AP_UpdateReferral_Request } from '@api-new/userservice/HTTP_AP_UpdateReferral_Request';
import { HTTP_AP_UpdateTinyUrl_Request } from '@api-new/userservice/HTTP_AP_UpdateTinyUrl_Request';
import { HTTP_AP_ValidateBulkSetClientUsersSettingsForNotifications_Response } from '@api-new/userservice/HTTP_AP_ValidateBulkSetClientUsersSettingsForNotifications_Response';
import { HTTP_CP_AddToPortfolioFolder_Request } from '@api-new/userservice/HTTP_CP_AddToPortfolioFolder_Request';
import { HTTP_CP_AdvisorUser } from '@api-new/userservice/HTTP_CP_AdvisorUser';
import { HTTP_CP_ClientUser } from '@api-new/userservice/HTTP_CP_ClientUser';
import { HTTP_CP_ClientUserSettingsForCreditReports } from '@api-new/userservice/HTTP_CP_ClientUserSettingsForCreditReports';
import { HTTP_CP_ClientUserSettingsForNotifications } from '@api-new/userservice/HTTP_CP_ClientUserSettingsForNotifications';
import { HTTP_CP_CreatePortfolioFolder_Request } from '@api-new/userservice/HTTP_CP_CreatePortfolioFolder_Request';
import { HTTP_CP_DeletePortfolioFolder_Request } from '@api-new/userservice/HTTP_CP_DeletePortfolioFolder_Request';
import { HTTP_CP_DoesEmailExist_Request } from '@api-new/userservice/HTTP_CP_DoesEmailExist_Request';
import { HTTP_CP_DoesEmailExist_Response } from '@api-new/userservice/HTTP_CP_DoesEmailExist_Response';
import { HTTP_CP_ListPortfolioFolders_Response } from '@api-new/userservice/HTTP_CP_ListPortfolioFolders_Response';
import { HTTP_CP_LoadClientUserData_Response } from '@api-new/userservice/HTTP_CP_LoadClientUserData_Response';
import { HTTP_CP_PortfolioFolder } from '@api-new/userservice/HTTP_CP_PortfolioFolder';
import { HTTP_CP_RemoveFromPortfolioFolder_Request } from '@api-new/userservice/HTTP_CP_RemoveFromPortfolioFolder_Request';
import { HTTP_CP_UpdateClientUserSettingsForCreditReports_Request } from '@api-new/userservice/HTTP_CP_UpdateClientUserSettingsForCreditReports_Request';
import { HTTP_CP_UpdateClientUserSettingsForNotifications_Request } from '@api-new/userservice/HTTP_CP_UpdateClientUserSettingsForNotifications_Request';
import { HTTP_CP_UpdateClientUser_Request } from '@api-new/userservice/HTTP_CP_UpdateClientUser_Request';
import { HTTP_CP_UpdatePortfolioFolder_Request } from '@api-new/userservice/HTTP_CP_UpdatePortfolioFolder_Request';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_ActivateReferrals(request: HTTP_AP_ActivateReferrals_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/ActivateReferrals`, request, options);
  }

  HTTP_AP_AddManagedAdvisorUsers(
    request: HTTP_AP_AddManagedAdvisorUsers_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_AddManagedAdvisorUsers_Response> {
    return this.httpClient.post(`/user-service/ap/AddManagedAdvisorUsers`, request, options);
  }

  HTTP_AP_AddManagedCompanies(
    request: HTTP_AP_AddManagedCompanies_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_AddManagedCompanies_Response> {
    return this.httpClient.post(`/user-service/ap/AddManagedCompanies`, request, options);
  }

  HTTP_AP_BulkCreateReferrals(request: HTTP_AP_BulkCreateReferrals_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/BulkCreateReferrals`, request, options);
  }

  HTTP_AP_BulkSetClientUsersSettingsForNotifications(
    request: HTTP_AP_BulkSetClientUsersSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/BulkSetClientUsersSettingsForNotifications`, request, options);
  }

  HTTP_AP_CreateAdvisorUser(request: HTTP_AP_CreateAdvisorUser_Request, options?: IRequestOptions): Observable<HTTP_AP_AdvisorUser> {
    return this.httpClient.post(`/user-service/ap/CreateAdvisorUser`, request, options);
  }

  HTTP_AP_CreateClientUser(request: HTTP_AP_CreateClientUser_Request, options?: IRequestOptions): Observable<HTTP_AP_ClientUser> {
    return this.httpClient.post(`/user-service/ap/CreateClientUser`, request, options);
  }

  HTTP_AP_CreateReferral(request: HTTP_AP_CreateReferral_Request, options?: IRequestOptions): Observable<HTTP_AP_Referral> {
    return this.httpClient.post(`/user-service/ap/CreateReferral`, request, options);
  }

  HTTP_AP_CreateTinyUrl(request: HTTP_AP_CreateTinyUrl_Request, options?: IRequestOptions): Observable<HTTP_AP_TinyUrl> {
    return this.httpClient.post(`/user-service/ap/CreateTinyUrl`, request, options);
  }

  HTTP_AP_DeactivateReferrals(request: HTTP_AP_DeactivateReferrals_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/DeactivateReferrals`, request, options);
  }

  HTTP_AP_DeleteAdvisorUser(request: HTTP_AP_DeleteAdvisorUser_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/user-service/ap/DeleteAdvisorUser`, { params: request });
  }

  HTTP_AP_DeleteClientUser(request: HTTP_AP_DeleteClientUser_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/user-service/ap/DeleteClientUser`, { params: request });
  }

  HTTP_AP_DeleteTinyUrl(request: HTTP_AP_DeleteTinyUrl_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/user-service/ap/DeleteTinyUrl`, { params: request });
  }

  HTTP_AP_ExportClientUsersToCSV(request: HTTP_AP_ExportClientUsersToCSV_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/ExportClientUsersToCSV`, request, options);
  }

  HTTP_AP_ExportReferralsToCSV(request: HTTP_AP_ExportReferralsToCSV_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/ExportReferralsToCSV`, request, options);
  }

  HTTP_AP_GetAdvisorUser(request: HTTP_AP_GetAdvisorUser_Request, options?: IRequestOptions): Observable<HTTP_AP_AdvisorUser> {
    return this.httpClient.get(`/user-service/ap/GetAdvisorUser`, { params: request });
  }

  HTTP_AP_GetAdvisorUserSettingsForNotifications(
    request: HTTP_AP_GetAdvisorUserSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetAdvisorUserSettingsForNotifications_Response> {
    return this.httpClient.get(`/user-service/ap/GetAdvisorUserSettingsForNotifications`, { params: request });
  }

  HTTP_AP_GetClientUser(request: HTTP_AP_GetClientUser_Request, options?: IRequestOptions): Observable<HTTP_AP_ClientUser> {
    return this.httpClient.get(`/user-service/ap/GetClientUser`, { params: request });
  }

  // FIXME #5860 TYPO: FortClientHeader -> Fort?
  HTTP_AP_GetClientUser_FortClientHeader(
    request: HTTP_AP_GetClientUser_FortClientHeader_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetClientUser_FortClientHeader_Response> {
    return this.httpClient.get(`/user-service/ap/GetClientUserFortClientHeader`, { params: request });
  }

  HTTP_AP_GetClientUserEmployment(
    request: HTTP_AP_GetClientUserEmployment_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ClientUserEmployment> {
    return this.httpClient.get(`/user-service/ap/GetClientUserEmployment`, { params: request });
  }

  HTTP_AP_GetClientUserSettingsForCreditReports(
    request: HTTP_AP_GetClientUserSettingsForCreditReports_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ClientUserSettingsForCreditReports> {
    return this.httpClient.get(`/user-service/ap/GetClientUserSettingsForCreditReports`, { params: request });
  }

  HTTP_AP_GetClientUserSettingsForNotifications(
    request: HTTP_AP_GetClientUserSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetClientUserSettingsForNotifications_Response> {
    return this.httpClient.get(`/user-service/ap/GetClientUserSettingsForNotifications`, { params: request });
  }

  HTTP_AP_GetReferral(request: HTTP_AP_GetReferral_Request, options?: IRequestOptions): Observable<HTTP_AP_Referral> {
    return this.httpClient.get(`/user-service/ap/GetReferral`, { params: request });
  }

  HTTP_AP_GetTinyUrl(request: HTTP_AP_GetTinyUrl_Request, options?: IRequestOptions): Observable<HTTP_AP_TinyUrl> {
    return this.httpClient.get(`/user-service/ap/GetTinyUrl`, { params: request });
  }

  HTTP_AP_ListAdvisorUserPermissionSettingsTemplates(
    request: HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListAdvisorUserPermissionSettingsTemplates_Response> {
    return this.httpClient.get(`/user-service/ap/ListAdvisorUserPermissionSettingsTemplates`, { params: request });
  }

  HTTP_AP_ListAdvisorUsers_ForSelect(
    request: HTTP_AP_ListAdvisorUsers_ForSelect_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListAdvisorUsers_ForSelect_Response> {
    return this.httpClient.get(`/user-service/ap/ListAdvisorUsers_ForSelect`, { params: request });
  }

  HTTP_AP_ListAdvisorUsers_ForTable(
    request: HTTP_AP_ListAdvisorUsers_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListAdvisorUsers_ForTable_Response> {
    return this.httpClient.get(`/user-service/ap/ListAdvisorUsers_ForTable`, { params: request });
  }

  HTTP_AP_ListClientUserEmails(
    request: HTTP_AP_ListClientUserEmails_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListClientUserEmails_Response> {
    return this.httpClient.post(`/user-service/ap/ListClientUserEmails`, request, options);
  }

  HTTP_AP_ListClientUserIds(
    request: HTTP_AP_ListClientUserIds_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListClientUserIds_Response> {
    return this.httpClient.post(`/user-service/ap/ListClientUserIds`, request, options);
  }

  HTTP_AP_ListClientUsers_ForBulkDeletion(
    request: HTTP_AP_ListClientUsers_ForBulkDeletion_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListClientUsers_ForBulkDeletion_Response> {
    return this.httpClient.post(`/user-service/ap/ListClientUsers_ForBulkDeletion`, request, options);
  }

  HTTP_AP_ListClientUsers_ForTable(
    request: HTTP_AP_ListClientUsers_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListClientUsers_ForTable_Response> {
    return this.httpClient.get(`/user-service/ap/ListClientUsers_ForTable`, { params: request });
  }

  HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement(
    request: HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCompaniesToManagingAdvisorUser_ForManagement_Response> {
    return this.httpClient.get(`/user-service/ap/ListCompaniesToManagingAdvisorUser_ForManagement`, { params: request });
  }

  HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement(
    request: HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListManagedToManagingAdvisorUser_ForManagement_Response> {
    return this.httpClient.get(`/user-service/ap/ListManagedToManagingAdvisorUser_ForManagement`, { params: request });
  }

  HTTP_AP_ListReferrals(request: HTTP_AP_ListReferrals_Request, options?: IRequestOptions): Observable<HTTP_AP_ListReferrals_Response> {
    return this.httpClient.get(`/user-service/ap/ListReferrals`, { params: request });
  }

  HTTP_AP_ListTinyUrls(request: HTTP_AP_ListTinyUrls_Request, options?: IRequestOptions): Observable<HTTP_AP_ListTinyUrls_Response> {
    return this.httpClient.get(`/user-service/ap/ListTinyUrls`, { params: request });
  }

  HTTP_AP_LoadAdvisorUserData(request?: undefined, options?: IRequestOptions): Observable<HTTP_AP_LoadAdvisorUserData_Response> {
    return this.httpClient.get(`/user-service/ap/LoadAdvisorUserData`, { params: request });
  }

  HTTP_AP_PurgeClientUsers(
    request: HTTP_AP_PurgeClientUsers_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_PurgeClientUsers_Response> {
    return this.httpClient.delete(`/user-service/ap/PurgeClientUsers`, { params: request });
  }

  HTTP_AP_ReassignAdvisorUsers(request: HTTP_AP_ReassignAdvisorUsers_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/ReassignAdvisorUsers`, request, options);
  }

  HTTP_AP_ReassignClientUsers(request: HTTP_AP_ReassignClientUsers_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/ReassignClientUsers`, request, options);
  }

  HTTP_AP_RemoveManagedAdvisorUsers(request: HTTP_AP_RemoveManagedAdvisorUsers_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/ap/RemoveManagedAdvisorUsers`, request, options);
  }

  HTTP_AP_RemoveManagedCompanies(
    request: HTTP_AP_RemoveManagedCompanies_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_RemoveManagedCompanies_Response> {
    return this.httpClient.post(`/user-service/ap/RemoveManagedCompanies`, request, options);
  }

  HTTP_AP_UpdateAdvisorUser(request: HTTP_AP_UpdateAdvisorUser_Request, options?: IRequestOptions): Observable<HTTP_AP_AdvisorUser> {
    return this.httpClient.put(`/user-service/ap/UpdateAdvisorUser`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserEmail(request: HTTP_AP_UpdateAdvisorUserEmail_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.patch(`/user-service/ap/UpdateAdvisorUserEmail`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserPermissionSettings(
    request: HTTP_AP_UpdateAdvisorUserPermissionSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_AdvisorUserPermissionSettings> {
    return this.httpClient.put(`/user-service/ap/UpdateAdvisorUserPermissionSettings`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserPhoneNumber(
    request: HTTP_AP_UpdateAdvisorUserPhoneNumber_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.patch(`/user-service/ap/UpdateAdvisorUserPhoneNumber`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserSettingsForNotifications(
    request: HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateAdvisorUserSettingsForNotifications_Response> {
    return this.httpClient.put(`/user-service/ap/UpdateAdvisorUserSettingsForNotifications`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserSettingsForPermissions(
    request: HTTP_AP_UpdateAdvisorUserSettingsForPermissions_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_AdvisorUserSettingsForPermissions> {
    return this.httpClient.put(`/user-service/ap/UpdateAdvisorUserSettingsForPermissions`, request, options);
  }

  HTTP_AP_UpdateClientUser(request: HTTP_AP_UpdateClientUser_Request, options?: IRequestOptions): Observable<HTTP_AP_ClientUser> {
    return this.httpClient.put(`/user-service/ap/UpdateClientUser`, request, options);
  }

  HTTP_AP_UpdateClientUserEmail(request: HTTP_AP_UpdateClientUserEmail_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.patch(`/user-service/ap/UpdateClientUserEmail`, request, options);
  }

  HTTP_AP_UpdateClientUserEmployment(
    request: HTTP_AP_UpdateClientUserEmployment_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ClientUserEmployment> {
    return this.httpClient.put(`/user-service/ap/UpdateClientUserEmployment`, request, options);
  }

  HTTP_AP_UpdateClientUserPhoneNumber(
    request: HTTP_AP_UpdateClientUserPhoneNumber_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.patch(`/user-service/ap/UpdateClientUserPhoneNumber`, request, options);
  }

  HTTP_AP_UpdateClientUserSettingsForCreditReports(
    request: HTTP_AP_UpdateClientUserSettingsForCreditReports_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ClientUserSettingsForCreditReports> {
    return this.httpClient.put(`/user-service/ap/UpdateClientUserSettingsForCreditReports`, request, options);
  }

  HTTP_AP_UpdateClientUserSettingsForNotifications(
    request: HTTP_AP_UpdateClientUserSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateClientUserSettingsForNotifications_Response> {
    return this.httpClient.put(`/user-service/ap/UpdateClientUserSettingsForNotifications`, request, options);
  }

  HTTP_AP_UpdateReferral(request: HTTP_AP_UpdateReferral_Request, options?: IRequestOptions): Observable<HTTP_AP_Referral> {
    return this.httpClient.put(`/user-service/ap/UpdateReferral`, request, options);
  }

  HTTP_AP_UpdateTinyUrl(request: HTTP_AP_UpdateTinyUrl_Request, options?: IRequestOptions): Observable<HTTP_AP_TinyUrl> {
    return this.httpClient.put(`/user-service/ap/UpdateTinyUrl`, request, options);
  }

  HTTP_AP_ValidateBulkSetClientUsersSettingsForNotifications(
    request: HTTP_AP_BulkSetClientUsersSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ValidateBulkSetClientUsersSettingsForNotifications_Response> {
    return this.httpClient.post(`/user-service/ap/ValidateBulkSetClientUsersSettingsForNotifications`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_AcceptTermsAndConditions(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/user-service/cp/AcceptTermsAndConditions`, request, options);
  }

  HTTP_CP_AddToPortfolioFolder(
    request: HTTP_CP_AddToPortfolioFolder_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_PortfolioFolder> {
    return this.httpClient.post(`/user-service/cp/AddToPortfolioFolder`, request, options);
  }

  HTTP_CP_CreatePortfolioFolder(
    request: HTTP_CP_CreatePortfolioFolder_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_PortfolioFolder> {
    return this.httpClient.post(`/user-service/cp/CreatePortfolioFolder`, request, options);
  }

  HTTP_CP_DeletePortfolioFolder(request: HTTP_CP_DeletePortfolioFolder_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/user-service/cp/DeletePortfolioFolder`, { params: request });
  }

  HTTP_CP_DoesEmailExist(request: HTTP_CP_DoesEmailExist_Request, options?: IRequestOptions): Observable<HTTP_CP_DoesEmailExist_Response> {
    return this.httpClient.post(`/user-service/cp/DoesEmailExist`, request, options);
  }

  HTTP_CP_GetAdvisorUser(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_AdvisorUser> {
    return this.httpClient.get(`/user-service/cp/GetAdvisorUser`, { params: request });
  }

  HTTP_CP_GetClientUser(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ClientUser> {
    return this.httpClient.get(`/user-service/cp/GetClientUser`, { params: request });
  }

  HTTP_CP_GetClientUserSettingsForCreditReports(
    request?: undefined,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserSettingsForCreditReports> {
    return this.httpClient.get(`/user-service/cp/GetClientUserSettingsForCreditReports`, { params: request });
  }

  HTTP_CP_GetClientUserSettingsForNotifications(
    request?: undefined,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserSettingsForNotifications> {
    return this.httpClient.get(`/user-service/cp/GetClientUserSettingsForNotifications`, { params: request });
  }

  HTTP_CP_ListPortfolioFolders(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListPortfolioFolders_Response> {
    return this.httpClient.get(`/user-service/cp/ListPortfolioFolders`, { params: request });
  }

  HTTP_CP_LoadClientUserData(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_LoadClientUserData_Response> {
    // FIXME
    //  New, not yet implemented endpoint for CP initialization
    //  Mirrors HTTP_AP_LoadAdvisorUserData in AP endpoints

    return this.httpClient.post(`/user-service/cp/LoadClientUserData`, request, options);
  }

  HTTP_CP_RemoveFromPortfolioFolder(
    request: HTTP_CP_RemoveFromPortfolioFolder_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_PortfolioFolder> {
    return this.httpClient.post(`/user-service/cp/RemoveFromPortfolioFolder`, request, options);
  }

  HTTP_CP_UpdateClientUser(request: HTTP_CP_UpdateClientUser_Request, options?: IRequestOptions): Observable<HTTP_CP_ClientUser> {
    return this.httpClient.put(`/user-service/cp/UpdateClientUser`, request, options);
  }

  // FIXME #5860 What the fuck is this endpoint name? An `Update` endpoint that's also a `Action`, that's very weird
  HTTP_CP_UpdateClientUser_DismissPropertyBanner(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ClientUser> {
    return this.httpClient.post(`/user-service/cp/UpdateClientUser_DismissPropertyBanner`, request, options);
  }

  HTTP_CP_UpdateClientUserSettingsForCreditReports(
    request: HTTP_CP_UpdateClientUserSettingsForCreditReports_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserSettingsForCreditReports> {
    return this.httpClient.put(`/user-service/cp/UpdateClientUserSettingsForCreditReports`, request, options);
  }

  HTTP_CP_UpdateClientUserSettingsForNotifications(
    request: HTTP_CP_UpdateClientUserSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserSettingsForNotifications> {
    return this.httpClient.put(`/user-service/cp/UpdateClientUserSettingsForNotifications`, request, options);
  }

  HTTP_CP_UpdatePortfolioFolder(
    request: HTTP_CP_UpdatePortfolioFolder_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_PortfolioFolder> {
    return this.httpClient.put(`/user-service/cp/UpdatePortfolioFolder`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/user-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // TODO #6091 Delete this after the AdvisorUserNotificationSettings -> AdvisorUserSettingsForNotifications migration is complete

  // TODO #6091 Delete this after the AdvisorUserPermissionSettings -> AdvisorUserSettingsForPermissions migration is complete

  // TODO #6091 Delete this after the ClientUserCreditReportSettings -> ClientUserSettingsForCreditReports migration is complete

  // TODO #6091 Delete this after the ClientUserNotificationSettings -> ClientUserSettingsForNotifications migration is complete
}
